import PropTypes from 'prop-types';

import { Abstrap } from '../..';

const propTypes = {
    ...Abstrap.propTypes,
    disabled: PropTypes.bool,
    status: PropTypes.oneOf(['error', 'valid', 'standard']).isRequired,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    disabled: false,
    status: 'standard',
};

class FormLine extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            disabled,
            status,
        } = this.props;
        return [
            'c-form__line',
            disabled ? 'c-form__line_disabled' : false,
            status === 'error' ? 'c-form__line_error' : false,
            status === 'valid' ? 'c-form__line_valide' : false,
            className,
        ];
    }

}

FormLine.propTypes = propTypes;

FormLine.defaultProps = defaultProps;

export default FormLine;
